import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { Toaster } from 'sonner';

// Public pages
import LandingPage from './pages/LandingPage';
import RegisterPage from './pages/RegisterPage';
import TenantLoginPage from './pages/TenantLoginPage';

// Super Admin
import SuperAdminLoginPage from './pages/SuperAdminLoginPage';
import SuperAdminDashboard from './pages/SuperAdminDashboard';

// School Admin (tenant)
import SchoolLayout from './components/SchoolLayout';
import SchoolDashboard from './pages/SchoolDashboard';
import SchoolStudentsPage from './pages/SchoolStudentsPage';
import SchoolTeachersPage from './pages/SchoolTeachersPage';
import SchoolClassesPage from './pages/SchoolClassesPage';
import SchoolEvaluationsPage from './pages/SchoolEvaluationsPage';
import SchoolUsersPage from './pages/SchoolUsersPage';

import './App.css';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#fafaf8]">
        <div className="w-8 h-8 border-2 border-emerald-600 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  return children;
};

function AppRoutes() {
  return (
    <Routes>
      {/* Public */}
      <Route path="/" element={<LandingPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/login" element={<TenantLoginPage />} />

      {/* Super Admin */}
      <Route path="/super-admin/login" element={<SuperAdminLoginPage />} />
      <Route path="/super-admin" element={<SuperAdminDashboard />} />

      {/* School Admin (tenant-aware) */}
      <Route path="/app" element={<ProtectedRoute><SchoolLayout /></ProtectedRoute>}>
        <Route path="dashboard" element={<SchoolDashboard />} />
        <Route path="students" element={<SchoolStudentsPage />} />
        <Route path="teachers" element={<SchoolTeachersPage />} />
        <Route path="classes" element={<SchoolClassesPage />} />
        <Route path="evaluations" element={<SchoolEvaluationsPage />} />
        <Route path="users" element={<SchoolUsersPage />} />
        <Route index element={<Navigate to="dashboard" replace />} />
      </Route>

      {/* Fallback */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
